import { useQuery } from 'react-query';

import { Announcement } from '../../../types/Announcement';
import { PaginatedList } from '../../../types/PaginatedList';
import Api from '../../api/api';

export const getAnnouncementsByPage = async (
  page: number,
  sort: string,
  search?: string,
  published?: boolean,
): Promise<PaginatedList<Announcement>> => {
  const [response, bodyOrError] = await Api.get(`announcement`, {
    page,
    sort,
    search,
    ...(published ? { published: true } : {}),
  });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetAnnouncementsByPage = ({
  page,
  sort,
  search = '',
  published,
}: {
  page: number;
  sort: string;
  search?: string;
  published?: boolean;
}) =>
  useQuery(['getAnnouncementsByPage', page, sort, search, published], () => getAnnouncementsByPage(page, sort, search, published), {
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
